import axios from "@/axios"

const url = "/api/brain/encaste/criadoras"
const url2 = "/api/lote/stages/fourth-stage/"

class CriadorasService {
	async getCriadoras(params) {
		try {
			const { data } = await axios.get(`${url}`, { params })
			return data
		} catch (error) {
			throw error
		}
	}

	async storeCriadoras(params) {
		try {
			const { data } = await axios.post(`${url}`, params)
			return data
		} catch (error) {
			return error.response
		}
	}

	async switchActive(id) {
		try {
			const { data } = await axios.put(`${url}/switch-active/${id}`)
			return data
		} catch (error) {
			return error.response
		}
	}
	async getTracking(id) {
		try {
			const { data } = await axios.get(`${url}/tracking/${id}`)
			return data
		} catch (error) {
			return error.response
		}
	}
}

export default new CriadorasService()
